import { render, staticRenderFns } from "./FunkoLogos.vue?vue&type=template&id=16b8ec15"
import script from "./FunkoLogos.vue?vue&type=script&lang=js"
export * from "./FunkoLogos.vue?vue&type=script&lang=js"
import style0 from "./FunkoLogos.vue?vue&type=style&index=0&id=16b8ec15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports